<template>
  <div id="app">
    <portal-target name="modals"></portal-target>
    <div class="app-preloader" v-if="app.showPreloader">
      <div style="position: flex">
        <h2>{{ app.title }}</h2>
      </div>
      <div class="app-loader"></div>
    </div>
    <layout :blocks="blocks" />
  </div>
</template>

<script>
  import router from './router';
  export default {
    name: 'appWrapper',
    router,
    computed: {
      app() {
        return window.app;
      },
    },
    methods: {
      set_active_blocks(blocks) {
        this.blocks = blocks;
      },
    },
    data: function () {
      return {
        blocks: [],
      };
    },
  };
</script>

<style>
  .app-loader {
    --c: no-repeat linear-gradient(orange 0 0);
    background: var(--c), var(--c), var(--c), var(--c), var(--c), var(--c), var(--c), var(--c), var(--c);
    background-size: 16px 16px;
    animation: l32-1 1s infinite, l32-2 1s infinite;
  }
  @keyframes l32-1 {
    0%,
    100% {
      width: 45px;
      height: 45px;
    }
    35%,
    65% {
      width: 65px;
      height: 65px;
    }
  }
  @keyframes l32-2 {
    0%,
    40% {
      background-position: 0 0, 0 50%, 0 100%, 50% 100%, 100% 100%, 100% 50%, 100% 0, 50% 0, 50% 50%;
    }
    60%,
    100% {
      background-position: 0 50%, 0 100%, 50% 100%, 100% 100%, 100% 50%, 100% 0, 50% 0, 0 0, 50% 50%;
    }
  }
  .app-preloader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.8);
    font-size: 1.5em;
    z-index: 1000;
    flex-direction: column;
  }
</style>
